import { hasSomeData, IRetirementScoreCalculationsOutput, runRetirementScoreCalculations } from 'app/calcs/Accountant'
import { INavRoute } from 'app/components/navigation/Nav/interfaces'
import { NavItem } from 'app/components/navigation/NavItem'
import { ProfileActions } from 'app/redux/Profile/actions'
import { Profile, SectionType } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { buildVersion, hasDevQueryParam, isDevelopmentMode } from 'config'
import * as _ from 'lodash'
import * as React from 'react'
import { ListGroupItem, MenuItem, NavDropdown } from 'react-bootstrap'
import * as ListGroup from 'react-bootstrap/lib/ListGroup'
import { Link, Redirect } from 'react-router-dom'

const tabletBreakpoint = 1200

interface INavProps {
  config: INavRoute[]
  currentPath: string
  brandImgUrl: string
  brandText: string
  onLogoutClicked?: () => void
  onResetProfile?: (a: string) => void
  breadcrumbName?: string
  breadcrumbPath?: string
  leftNavDescription?: JSX.Element,
  username: string,
  profile: Profile
}

interface INavState {
  isBusy: boolean,
  scoreOutputs: IRetirementScoreCalculationsOutput
}

const debug = utils.makeDebug(false)

class Nav extends React.Component<INavProps, INavState> {

  debounceStoreProfile = _.debounce((profile: Profile) => ProfileActions.store(profile), 500)
  private lastProfile: Profile

  componentWillMount() {
    this.state = {
      isBusy: false,
      scoreOutputs: {
        analysis: undefined,
        insights: [],
        score: 95,
        scorePhrase: 'on target',
        timeline: null
      }
    }

  }

  componentWillUpdate(nextProps: INavProps, nextState: INavState) {
    // wait for a profile to show up
    if (!nextProps.profile) { return }

    const same = _.isEqual(nextProps.profile, this.lastProfile)
    if (same) { return }
    debug('nav component will update scores')
    this.lastProfile = _.cloneDeep(nextProps.profile)

    this.setState({ isBusy: true })
    runRetirementScoreCalculations(nextProps.profile)
      .then((scoreOutputs) => {
        const { averageMonthlyNetIncome, averageMonthlyExpenses, grossIncome, score } = scoreOutputs.analysis
        //debug('nav sees new scores ' + JSON.stringify({ averageMonthlyNetIncome, averageMonthlyExpenses, grossIncome, score }))
        this.setState({ isBusy: false, scoreOutputs })
      })
  }

  mapNavRouteToNavItem(config: INavRoute, index: number) {
    if (config.hidden) { return null }

    if (config.multi) {
      return (
        <NavItem key={index} currentPath={this.props.currentPath} multiConfig={config.multi} />
      )
    } else if (config.single) {
      return (
        <NavItem key={index} currentPath={this.props.currentPath} singleConfig={config.single} />
      )
    }
  }

  render() {

    const haveScore = 0 !== this.state.scoreOutputs.score
    const somethingToShow = haveScore && hasSomeData(this.state.scoreOutputs)
    const showResets = isDevelopmentMode || hasDevQueryParam

    return (
      <nav>
        <aside className="left-nav">
          <section className="left-brand">
            <img alt="Brand" src={this.props.brandImgUrl} />

            <section className="left-brand-name">
              <header>{this.props.brandText}</header>
              <ul className="list-unstyled">
                <NavDropdown id="basic-nav-dropdown" title="Profile" className="edit-profile">
                  <li className="dropdown-header"><i className="fa fa-user-circle fa-fw"></i> {this.props.username}</li>
                  <MenuItem href="#/profile"><i className="fa fa-pencil-square fa-fw"></i> Edit Profile</MenuItem>
                  {showResets && <MenuItem onClick={() => this.props.onResetProfile('basic')}><i className="fa fa-bomb fa-fw"></i> Nuke Basic Profile</MenuItem>}
                  {showResets && <MenuItem onClick={() => this.props.onResetProfile('retirement')}><i className="fa fa-bomb fa-fw"></i> Nuke Retirement Savings</MenuItem>}
                  {showResets && <MenuItem onClick={() => this.props.onResetProfile('pension')}><i className="fa fa-bomb fa-fw"></i> Nuke Pension</MenuItem>}
                  {showResets && <MenuItem onClick={() => this.props.onResetProfile('expenses')}><i className="fa fa-bomb fa-fw"></i> Nuke Expenses</MenuItem>}
                  {this.props.onLogoutClicked ? <MenuItem divider /> : null}
                  {this.props.onLogoutClicked ?
                    <MenuItem onClick={() => this.props.onLogoutClicked()}><i className="fa fa-power-off fa-fw"></i> Log Off <small>(v. {buildVersion})</small></MenuItem>
                    : null
                  }
                </NavDropdown>
              </ul>
            </section>
          </section>

          {somethingToShow && !this.state.isBusy &&
            <section className="left-nav-description">
              <h6 className="lead">Your retirement summary is available <br />
                <small><a href="#/Results/summary" className="small">
                  <i className="fa fa-fw fa-info-circle" />
                  What does this mean?
            </a></small></h6>
              <hr />
            </section>
          }
          {somethingToShow && this.state.isBusy &&
            <section className="left-nav-description">
              <h6 className="lead">Hang on, we're crunching some numbers...<br />
                <small><a href="#/Results/summary" className="small">
                  <i className="fa fa-fw fa-info-circle" />
                  What does this mean?
              </a></small></h6>
              <hr />
            </section>
          }
          {!somethingToShow &&
            <section className="left-nav-description">
              <h6 className="lead">(insufficient data to show summary)<br />
                <small><a href="#/Results/summary" className="small">
                  <i className="fa fa-fw fa-info-circle" />
                  What does this mean?
              </a></small></h6>
              <hr />
            </section>
          }

          <ListGroup className="list-group-clear">
            {this.props.breadcrumbName ?
              <ListGroupItem className="list-group-item-unstyled breadcrumbs">
                <Link to="/dashboard" className="text-muted">Dashboard</Link>
                <i className="fa fa-fw fa-lg fa-angle-right text-success" />
                <Link to={this.props.breadcrumbPath} className="text-muted">{this.props.breadcrumbName}</Link>
              </ListGroupItem>
              : null
            }

            {this.props.config.map((config, index) => this.mapNavRouteToNavItem(config, index))}

          </ListGroup>

        </aside>
      </nav>
    )
  }
}

export {
  Nav
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/Nav/index.tsx